export const PROTOCOL = [
  "https",
  "http",
  "tcp",
  "udp",
  "ip",
  "pop",
  "smtp",
  "dhcp",
  "l2tp",
  "ftp",
  "imap",
];
